import React, { useState, useEffect } from 'react';

import TextInfo, {
  TEXT_COLOR,
} from '@gc-npm/components.text';
import Price, {
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
} from '@gc-npm/components.price';
import InputNumber from '@/components/InputNumber';

const COMPONENT_NAME = 'mobileLineCard';

const MobileLineCard = ({
  module, onClick, linesToPurchase, taggingInfo,
}) => {
  const {
    title,
    price,
    id,
    characteristics,
    minQuantity,
  } = module;
  const minimumQuantity = Number(minQuantity) || 0;
  const [lineQuantity, setLineQuantity] = useState(
    Math.max(Number(linesToPurchase[id]) || 0, minimumQuantity),
  );
  
const charactList =
  characteristics?.['Líneas móviles']
    ?.filter(item => item.key.includes('configCard'))
    .map(item => item.text);

  const blockPlusLines = false;
  const blockMinusLines = lineQuantity <= minimumQuantity;

  useEffect(() => {
    onClick({
      ...linesToPurchase,
      [id]: lineQuantity,
    });
  }, [lineQuantity]);

  return (
    <div className="MobileLineCard">
      <div className="content">
        <div className="title">
          <TextInfo {...title} />
        </div>
        <div className="characs">
          {charactList && charactList.map((eachCharac) => <TextInfo text={eachCharac} />)}
        </div>
        <div className="price">
          <Price
            {...price}
            color={TEXT_COLOR.GREY6}
            currency="€"
            fontType={PRICE_FONT_WEIGHT.BOLD}
            fontTypeUnity={PRICE_FONT_WEIGHT.BOLD}
            size={PRICE_SIZE.XS}
          />
        </div>
        <div className="counter">
          <InputNumber
            value={lineQuantity}
            min={minimumQuantity}
            onChange={(quantity) => setLineQuantity(Math.max(quantity, minimumQuantity))}
            max={99}
            blockMinusLines={blockMinusLines}
            blockPlusLines={blockPlusLines}
            taggingInfo={{
              ...taggingInfo,
              componentName: COMPONENT_NAME,
              componentProduct: title.title,
              componentContent: `cantidad-${lineQuantity}`,
            }}
          />
        </div>

      </div>
      <style jsx>
        {`
            .MobileLineCard{
                margin-top:1rem;
                border: 1px solid rgb(238, 238, 238);
                width: 20rem;
                background-color: rgb(255, 255, 255);
                border-radius: 1rem;
                padding: 1rem;
                .characs{
                    margin-bottom: 0.5rem;
                }
                .price{
                    margin-bottom: 2rem;
                }
                .counter{
                    width: fit-content;
                }
            }
            @media screen and (max-width: 768px) {
                .MobileLineCard{
                    width: 17rem;
                }
            }
            `}
      </style>
    </div>
  )
}
export default MobileLineCard;
